export default __webpack_public_path__ + "static/media/musicMsteringIcon.1b44c193.png";